export default __webpack_public_path__ + "navigation-examples-electronic-horizon-thumbnail-480-763e4df668bd77b3a60ce3319fa4b545.webp";